import styled from '@emotion/styled/macro';
import vars from '@variables';

export const Wrapper = styled.div`
  position: fixed;
  bottom: -400px;
  left: 0;
  right: 0;
  width: 100%;
  background-color: rgba(0, 108, 160, 1);
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: solid 1.5rem rgba(#000, 0.2);
  padding: 3.2rem;
  z-index: 99;
  overflow: hidden;
  transition: 0.3s ease-in-out;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  > svg {
    position: absolute;
    right: 10%;
    top: 100%;
    transform: translateY(-50%);
  }

  form {
    margin-top: ${vars.spacingM};
    margin-bottom: ${vars.spacingL};
  }

  input {
    ${vars.fontSize4}
    font-weight: ${vars.fontWeightBold};
    padding: ${vars.spacingM} ${vars.spacingS};
    border-radius: 4px;
    border: 0;
    text-align: center;
    letter-spacing: 0.15%;
  }

  button {
    ${vars.fontSize4}
    font-weight: ${vars.fontWeightBold};
    background-color: rgba(217, 217, 217, 1);
    margin-left: ${vars.spacingS};
    padding: ${vars.spacingM} ${vars.spacingL};
    border-radius: 4px;
    border: 0;
    letter-spacing: 0.15%;

    &:hover {
      cursor: pointer;
    }
  }

  i {
    font-size: 14px;
    color: white;
  }
`;

export const Title = styled.h2`
  font-weight: ${vars.fontWeightBold};
  font-size: 3.8rem;
  letter-spacing: -2%;
  margin-bottom: ${vars.spacingL};
  color: white;
`;

export const Text = styled.p`
  font-weight: ${vars.fontWeightRegular};
  ${vars.fontSize4}
  margin-bottom: ${vars.spacingS};
  color: white;
`;

export const Italic = styled.p`
  font-weight: ${vars.fontWeightRegular};
  ${vars.fontSize4}
  margin-bottom: ${vars.spacingS};
  color: white;
  font-style: italic;
`;

export const BackgroundOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 90;
`;

export const Error = styled.p`
  font-weight: ${vars.fontWeightBold};
  font-size: 1.4rem;
  margin-bottom: ${vars.spacingM};
  color: #ff7373;
`;
